<template>
  <HScaffold title="设置">
    <HCellGroup :data="cellGroupData"/>
    <HCellGroup :data="cellGroupData2"/>
    <HButton title="安全退出" :callback="exitAccount"/>
  </HScaffold>
</template>


<script setup>

  import HScaffold from "@/components/utils/HScaffold.vue";
  import HCellGroup from "@/components/utils/HCellGroup.vue";
  import {hr} from "@/components/utils/HRouter.js";
  import {showToast} from "vant";
  import {hdi} from "@/components/utils/HDeviceInfo.js";
  import HButton from "@/components/utils/HButton.vue"
  import {useHHttp} from "@/hooks/useHHttp.js";
  import {useUserStore} from "@/stores/useUser.js";
  import {useHComApi} from "@/hooks/useHComApi.js";
  import {emitter} from "@/components/utils/HComFunctions.js";
  const useHttp = useHHttp();
  const useUser = useUserStore();

  function exitAccount(){
    useHttp.request("/app/login-out", (resp)=>{
      hr.goBack();
      useUser.removeUserInfo();
      //清除http的header中的token
      useHttp.setToken();
      showToast("账号已安全退出");
      useHComApi().updateAppConfig();
      emitter.emit(
          "REFRESH_HOME_LOBBY_LIST");
    }, {
      params: {"UserId": useUser.userId}});
  }

  const cellGroupData = ref([
    {
      "icon": "",
      "title": "网络与设备",
      "rightText": "查看详情",
      "callBack": () => {
        hr.go("device");
      }
    },
    {
      "icon": "",
      "title": "关于我们",
      "rightText": "",
      "callBack": () => {
        hr.go("about");
      }
    },
  ]);
  const cellGroupData2 = ref([
    {
      "icon": "",
      "title": "检查更新",
      "rightText": hdi.appVersion,
      "callBack": () => {
          showToast("当前已是最新版本");
    }
  },
  ]);

</script>


<style scoped>
</style>
